import type { SymbolDefinition } from "../types.ts";

export const socketOutlet: SymbolDefinition = {
  id: "ep-socket",
  familyKey: "socket",
  deviceKind: "connector",
  version: "0.1.0",
  label: { sv: "Vägguttag", en: "Wall outlet" },
  description: { sv: "230 V vägguttag med jord.", en: "230 V socket with earth." },
  viewBox: "0 0 24 24",
  svg: `
    <g fill="none" stroke="currentColor" stroke-width="1.5">
      <path d="M 4 14 A 8 8 0 0 1 20 14 Z"/>
      <line x1="4" y1="14" x2="20" y2="14"/>
      <line x1="12" y1="14" x2="12" y2="22"/>
    </g>
  `,
  terminals: [
    { id: "L", kind: "phase", label: "L", position: "bottom", offset: 0.25 },
    { id: "N", kind: "neutral", label: "N", position: "bottom", offset: 0.5 },
    { id: "PE", kind: "earth", label: "PE", position: "bottom", offset: 0.75 },
  ],
  designationPrefix: "X",
  searchKeywords: ["uttag", "vägguttag", "socket"],
};
